import { render } from "./StreamsManageAnalyticsInputHealthCharts.vue?vue&type=template&id=3237be6d"
import script from "./StreamsManageAnalyticsInputHealthCharts.vue?vue&type=script&lang=js"
export * from "./StreamsManageAnalyticsInputHealthCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__